<template>
    <div class="Product">
      <div class="content">
        <img :src="ImageUrl" class="img-fluid" alt="Responsive image">
        <div class="content-detail">
          <h1 data-delighter class="left">印点点共享打印系统</h1>
          <p data-delighter class="right" style="margin-top:50px">DIY自己专属的打印品牌</p>
          <p data-delighter class="right"> 15000+打印网点在使用</p>
        </div>
      </div>
  
      <div class="container">
        <div class="row" style="text-align: center;">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck card-list">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                <img class="icon" src="../assets/ShopSharePrinting/advert_1.png" alt="Card image cap">
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                <h2>手机自助打印软件</h2>
                <p class="secd">用户使用微信、QQ扫码发送文件，控制打印机直接打印</p>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">特点：</p>
                  <p class="secd">不占用电脑、优化成本高峰分流、提高营收操作简便、吸引客户</p>
                </div>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">流程：</p>
                  <p class="secd" style="margin: 4px 0;">1、扫码发送文件</p>
                  <p class="secd" style="margin: 4px 0;">2、自动计价，微信支付</p>
                  <p class="secd" style="margin: 4px 0;">3、打印完成，领取文件</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div style="background-color: #F1F9FF;">
        <div class="container">
          <div class="row" style="text-align: center;">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="card-deck card-list">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                  <h2>远程（预约）自助打印系统</h2>
                  <p class="secd">用户通过公众号或小程序端上传文件，可选择自取或配送</p>
                  <div style="margin-top: 20px;">
                    <p style="color: #0073CA;font-size: 24px;font-weight: 500;">特点：</p>
                    <p class="secd">全天候24小时接单 ｜ 预先支付，防止损耗 ｜ 集中打印、合理分配人力设备</p>
                  </div>
                  <div style="margin-top: 20px;">
                    <p style="color: #0073CA;font-size: 24px;font-weight: 500;">流程：</p>
                    <p class="secd" style="margin: 4px 0;">1、在线上传、支付订单</p>
                    <p class="secd" style="margin: 4px 0;">2、商家处理订单</p>
                    <p class="secd" style="margin: 4px 0;">3、到店自取，送货上门</p>
                  </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                  <img class="icon" src="../assets/ShopSharePrinting/advert_2.png" alt="Card image cap">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="container" style="text-align: center;padding: 100px 0;">
        <h2 style="margin-bottom: 30px;">资金清算安全</h2>
        <p class="secd" style="margin: 4px 0;">商家办理独立收款码，交易资金不经过平台清算，</p>
        <p class="secd" style="margin: 4px 0;">由正规支付机构清算到商家银行可，保障资金清算合法合规</p>
      </div>
  
      <div style="text-align: center;padding: 100px 0;background-color: #F1F9FF;">
        <div class="container">
          <h2 style="margin-bottom: 30px;">多版本 任您选择</h2>
          <p class="secd" style="margin: 4px 0;">再好的产品只有经过消费才能产生财富，</p>
          <p class="secd" style="margin: 4px 0;">再好的方案只有适合自己的，才是最好的！</p>
          <p class="secd" style="margin: 4px 0;">考虑到广大商家及企业的不同场景需要，</p>
          <p class="secd" style="margin: 4px 0;">我们推出三种方案可供选择，真正做到量身定制，契合匹配</p>
        </div>
        <div class="container" style="margin-top: 80px;">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="card-deck">
                <div class="card card-kind ">
                  <h4 class="version-tit">加盟版<span class="secd" style="font-size: 16px;">（免费）</span></h4>
                  <div class="card-body">
                    <img class="version-img" src="../assets/ShopSharePrinting/version_1.png" alt="Card image cap">
                    <p class="card-title tit-h">免费试用自助打印系统</p>
                    <!-- <h4 class="card-title">高校免费</h4> -->
                    <p class="card-text secd" style="margin-top: 52px;">零投入 拿来直接运营</p>
                  </div>
                </div>
                <div class="card card-kind">
                  <h4 class="version-tit">门店版<span class="secd" style="font-size: 16px;">（付费）</span></h4>
                  <div class="card-body">
                    <img class="version-img" src="../assets/ShopSharePrinting/version_2.png" alt="Card image cap">
                    <p class="card-title tit-h">可增加门店·自营品牌·适合投放</p>
                    <!-- <h4 class="card-title">6000元/终生</h4> -->
                    <p class="card-text secd">（含多家门店）</p>
                    <p class="card-text secd">电脑端+公众号+小程序+专属服务器</p>
                  </div>
                </div>
                <div class="card card-kind">
                  <h4 class="version-tit">旗舰版<span class="secd" style="font-size: 16px;">（付费）</span></h4>
                  <div class="card-body">
                    <img class="version-img" src="../assets/ShopSharePrinting/version_3.png" alt="Card image cap">
                    <p class="card-title tit-h">门店无限开·无限制</p>
                    <!-- <h4 class="card-title">10万元/终生</h4> -->
                    <p class="card-text secd">（门店不限）</p>
                    <p class="card-text secd">电脑端+公众号+小程序+专属服务器</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div style="margin: 20px 0;">
        <div v-for="(item, index) in dataList" :key="'dataList' + index">
          <div style="background-color: #F1F9FF;">
            <div class="container" style="text-align: center;padding: 37px 0;">
              <div class="row">
                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="text-align: right;font-size: 24px;">
                  {{ item.name }}
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                  加盟版
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                  独立门店版
                </div>
                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                  独立旗舰版
                </div>
              </div>
            </div>
          </div>
          <div class="container" style="text-align: center;">
            <div class="row" v-for="(items, index) in item.list" :key="items.label + index"
              style="line-height: 50px;border-bottom: 1px solid #F5F6F8;">
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="text-align: right;">
                {{ items.label }}
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <img v-if="items.v1 === true" src="../assets/ShopSharePrinting/yes.png">
                <img v-else-if="items.v1 === false" src="../assets/ShopSharePrinting/no.png">
                <span v-else>{{ items.v1 }}</span>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <img v-if="items.v2 === true" src="../assets/ShopSharePrinting/yes.png">
                <img v-else-if="items.v2 === false" src="../assets/ShopSharePrinting/no.png">
                <span v-else>{{ items.v2 }}</span>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <img v-if="items.v3 === true" src="../assets/ShopSharePrinting/yes.png">
                <img v-else-if="items.v3 === false" src="../assets/ShopSharePrinting/no.png">
                <span v-else>{{ items.v3 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  <script>
  
  export default {
    data() {
      return {
        ImageUrl: require('../assets/ShopSharePrinting/banner.png'),
        dataList: [
          {
            name: "版本功能比较", list: [
              { label: "电脑自助打印", v1: true, v2: true, v3: true },
              { label: "微信公众号自助打印", v1: true, v2: true, v3: true },
              { label: "微信小程序自助打印", v1: true, v2: true, v3: true },
              { label: "QQ小程序自助打印", v1: true, v2: true, v3: true },
              { label: "远程预约打印", v1: true, v2: true, v3: true },
              { label: "自动计价", v1: true, v2: true, v3: true },
              { label: "营销活动", v1: true, v2: true, v3: true },
              { label: "会员充值", v1: true, v2: true, v3: true },
              { label: "文档打印", v1: true, v2: true, v3: true },
              { label: "照片打印", v1: true, v2: true, v3: true },
              { label: "证件照制作", v1: true, v2: true, v3: true },
              { label: "文件复印", v1: true, v2: true, v3: true },
              { label: "电子发票打印", v1: true, v2: true, v3: true },
              { label: "分账管理", v1: true, v2: true, v3: true },
              { label: "多门店管理", v1: false, v2: true, v3: true },
              { label: "微信公众号管理", v1: false, v2: true, v3: true },
              { label: "品牌logo定制", v1: false, v2: true, v3: true },
              { label: "广告对接", v1: false, v2: true, v3: true },
              { label: "微信支付推荐关注公众号", v1: false, v2: true, v3: true },
            ]
          },
          {
            name: "服务内容", list: [
              { label: "提供教程文档", v1: true, v2: true, v3: true },
              { label: "bug反馈及响应", v1: true, v2: true, v3: true },
              { label: "网站部署对接", v1: false, v2: true, v3: true },
              { label: "公众号部署对接", v1: false, v2: true, v3: true },
              { label: "小程序部署对接", v1: false, v2: true, v3: true },
              { label: "定制开关", v1: false, v2: true, v3: true },
            ]
          },
          {
            name: "服务期限", list: [
              { label: "授权使用权限", v1: "终身", v2: "终身", v3: "终身" },
              { label: "免费更新期限", v1: "终身", v2: "终身", v3: "终身" },
              { label: "产品使用培训", v1: true, v2: true, v3: true },
            ]
          },
        ],
      }
    },
    created() {
      window.scrollTo(0, 0);
    },
    mounted() {
  
    }
  };
  </script>
  
  <style lang="less" scoped>
  .content {
    width: 100%;
    position: relative;
    background: no-repeat center center;
    background-size: cover;
  }
  
  .secd {
    color: #666666;
  }
  
  
  
  
  
  .card-list {
    padding: 200px 0 158px;
  }
  
  .card-kind {
    border: 0px;
    background-color: inherit;
  
    .version-tit {
      padding-bottom: 50px;
      position: relative;
  
      &::after {
        content: "";
        width: 64px;
        height: 3px;
        background-color: #00CD95;
        position: absolute;
        border-radius: 99px;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  
    .card-body {
  
      background-color: #fff;
      padding: 50px 0;
      transition: all 0.2s;
  
      &:hover {
        transform: scale(1.1, 1.1);
      }
  
      .version-img {
        width: 120px;
        height: 120px;
        box-shadow: 8px 14px 25px 1px rgba(0, 255, 185, 0.2);
        margin-bottom: 20px;
      }
  
      .tit-h {
        color: #00CD95;
        font-weight: 500;
      }
    }
  
    &:nth-child(2) {
      .version-tit::after {
        background-color: #FF725E;
      }
  
      .tit-h {
        color: #FF725E;
      }
  
      .version-img {
        box-shadow: 8px 14px 25px 1px rgba(255, 114, 94, 0.2);
      }
    }
  
    &:nth-child(3) {
      .version-tit::after {
        background-color: #00CBF1;
      }
  
      .tit-h {
        color: #00CBF1;
      }
  
      .version-img {
        box-shadow: 8px 14px 25px 1px rgba(0, 203, 241, 0.2);
      }
    }
  
  
  }
  
  .list-icon {
    display: flex;
    justify-content: center;
    position: relative;
  }
  
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    height: 221px;
  }
  
  .list-item {
    text-align: left;
  
    h2 {
      font-size: 40px;
      line-height: 28px;
      color: #18182a;
      margin-bottom: 24px;
    }
  
    p {
      font-size: 16px;
      line-height: 28px;
      color: #555;
    }
  
  
  }
  
  
  .content-detail {
    position: absolute;
    top: 8rem;
    left: 15vw;
  
    h1 {
      font-size: 2.8rem;
      line-height: 2rem;
      color: #fff;
    }
  
    p {
      font-size: 1.75rem;
      color: #fff;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/ShopSharePrinting.vue